<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30" [attr.fill]="color">
  <circle cx="15" cy="15" r="8" style="stroke-width:4px;stroke:#FFF"/>
</svg>
